/**
    * @fileoverview Generated Platform Configuration
    * @description Auto-generated during token build process
    * @generated 2025-12-11T17:39:10.885Z
    */

    export const CURRENT_PLATFORM = "mobile" as const;

    export type Platform = "tv" | "web" | "mobile";
  